const TOKEN_KEY = "staymaster_token";
const RESTAURANT_ID_KEY = "staymaster_linked_restaurant_id";

/**
 * StayMaster's sidebar ("Restaurant POS" link) appends its own logged-in
 * user's access token — and, if that property has one set, its linked
 * restaurant id — to this app's URL as a query-string-style hash, e.g.
 *   http://localhost:3001/login#staymaster_token=<token>&restaurant_id=<id>
 *
 * This lets Room Service use whichever StayMaster account the client is
 * already signed in as — no shared/hardcoded credentials needed, and it
 * works for any client's account, not just ones we know the password for.
 *
 * Call this once on app start. It stores both values and strips them from
 * the URL so nothing is left visible in the address bar or browser history.
 */
export const captureStaymasterTokenFromUrl = () => {
  const hash = window.location.hash || "";

  if (!hash.startsWith("#")) return;

  const params = new URLSearchParams(hash.slice(1));
  const token = params.get("staymaster_token");
  const restaurantId = params.get("restaurant_id");

  if (!token) return;

  localStorage.setItem(TOKEN_KEY, token);

  if (restaurantId) {
    localStorage.setItem(RESTAURANT_ID_KEY, restaurantId);
  }

  window.history.replaceState(
    null,
    "",
    window.location.pathname + window.location.search
  );
};
